import { Button } from '@/components/ui/button';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DayContentProps } from 'react-day-picker';
import dayjs from 'dayjs';

export function DayContent({
  date,
  currentSelectedDate,
  hasOpenTodos,
}: Pick<DayContentProps, 'date'> & {
  currentSelectedDate: Date;
  hasOpenTodos?: boolean;
}) {
  return (
    <div className="relative">
      {hasOpenTodos && (
        <FontAwesomeIcon
          className="absolute top-[5px] right-[5px] size-[5px] text-primary-red-R400"
          icon={faCircle}
        />
      )}
      <Button
        variant="ghost"
        className={`h-9 w-9 font-normal bg-transparent ${
          dayjs(currentSelectedDate).isSame(date, 'date')
            ? 'hover:bg-primary-blue-B600 focus-visible:bg-primary-blue-B600'
            : 'hover:bg-neutrals-N300'
        }`}
        id={date.toISOString()}>
        {date.getDate()}
      </Button>
    </div>
  );
}
